const createLocalizationHandlers = ({
    appLocalizationComponent,
}: Pick<CommanderContainer, 'appLocalizationComponent'>) => {
    const {
        localizeCurrencyValue,
        localizeDate,
        localizeDateTime,
        localizeEnumify,
        localizeNumber,
        localizePercent,
        localizeProperty,
        localizeShortDate,
        localizeShortTime,
        localizeWallClockDate,
    } = appLocalizationComponent;

    type InjectLangCodeArg<TFunction extends (...args: any[]) => unknown> = (
        ...args: [lCode: string, ...Parameters<TFunction>]
    ) => ReturnType<TFunction>;

    return {
        localizeCurrencyValue: ((lCode, { value, currency }, ...args) =>
            localizeCurrencyValue({ value, currency }, ...args)) satisfies InjectLangCodeArg<
            typeof localizeCurrencyValue
        >,
        localizeDate: ((lCode, ...args) => localizeDate(...args)) satisfies InjectLangCodeArg<typeof localizeDate>,
        localizeDateTime: ((lCode, ...args) => localizeDateTime(...args)) satisfies InjectLangCodeArg<
            typeof localizeDateTime
        >,
        localizeEnumify: ((lCode, ...args) => localizeEnumify(...args)) satisfies InjectLangCodeArg<
            typeof localizeEnumify
        >,
        localizeNumber: ((lCode, ...args) => localizeNumber(...args)) satisfies InjectLangCodeArg<
            typeof localizeNumber
        >,
        localizePercent: ((lCode, ...args) => localizePercent(...args)) satisfies InjectLangCodeArg<
            typeof localizePercent
        >,
        localizeProperty: ((lCode, ...args) => localizeProperty(...args)) satisfies InjectLangCodeArg<
            typeof localizeProperty
        >,
        localizeShortDate: ((lCode, ...args) => localizeShortDate(...args)) satisfies InjectLangCodeArg<
            typeof localizeShortDate
        >,
        localizeShortTime: ((lCode, ...args) => localizeShortTime(...args)) satisfies InjectLangCodeArg<
            typeof localizeShortTime
        >,
        localizeWallClockDate: ((lCode, ...args) => localizeWallClockDate(...args)) satisfies InjectLangCodeArg<
            typeof localizeWallClockDate
        >,
    };
};

export default createLocalizationHandlers;
export type LocalizationHandlers = ReturnType<typeof createLocalizationHandlers>;
